export default "__VITE_ASSET__DmHkW_BV__"